'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toptips = require('./toptips');

var _toptips2 = _interopRequireDefault(_toptips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _toptips2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/toptips/index.js
// module id = 1802
// module chunks = 7